import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
  namespaced: true,
  state: {
    countries: {
      '': '--Please select--',
      AF: 'AFGHANISTAN',
      AL: 'ALBANIA',
      DZ: 'ALGERIA',
      AS: 'AMERICAN SAMOA',
      AD: 'ANDORRA',
      AO: 'ANGOLA',
      AR: 'ARGENTINA',
      AM: 'ARMENIA',
      AW: 'ARUBA',
      AU: 'AUSTRALIA',
      AT: 'AUSTRIA',
      AZ: 'AZERBAIJAN',
      BS: 'BAHAMAS',
      BH: 'BAHRAIN',
      BD: 'BANGLADESH',
      BB: 'BARBADOS',
      BY: 'BELARUS',
      BE: 'BELGIUM',
      BZ: 'BELIZE',
      BJ: 'BENIN',
      BM: 'BERMUDA',
      BT: 'BHUTAN',
      BO: 'BOLIVIA',
      BA: 'BOSNIA',
      BW: 'BOTSWANA',
      BV: 'BOUVET ISLAND',
      BR: 'BRAZIL',
      BG: 'BULGARIA',
      BF: 'BURKINA FASO',
      BI: 'BURUNDI',
      KH: 'CAMBODIA',
      CM: 'CAMEROON',
      CA: 'CANADA',
      CV: 'CAPE VERDE',
      KY: 'CAYMAN ISLANDS',
      TD: 'CHAD',
      CL: 'CHILE',
      CN: 'CHINA',
      CX: 'CHRISTMAS ISLAND',
      CO: 'COLOMBIA',
      KM: 'COMOROS',
      CG: 'CONGO',
      CR: 'COSTA RICA',
      CI: 'CÔTE D\'IVOIRE',
      HR: 'CROATIA',
      CU: 'CUBA',
      CY: 'CYPRUS',
      CZ: 'CZECH REPUBLIC',
      DK: 'DENMARK',
      DJ: 'DJIBOUTI',
      DM: 'DOMINICA',
      DO: 'DOMINICAN REPUBLIC',
      EC: 'ECUADOR',
      EG: 'EGYPT',
      SV: 'EL SALVADOR',
      GQ: 'EQUATORIAL GUINEA',
      ER: 'ERITREA',
      EE: 'ESTONIA',
      ET: 'ETHIOPIA',
      FK: 'FALKLAND ISLANDS (MALVINAS)',
      FO: 'FAROE ISLANDS',
      FJ: 'FIJI',
      FI: 'FINLAND',
      FR: 'FRANCE',
      GF: 'FRENCH GUIANA',
      GA: 'GABON',
      GM: 'GAMBIA',
      GE: 'GEORGIA',
      DE: 'GERMANY',
      GH: 'GHANA',
      GI: 'GIBRALTAR',
      GR: 'GREECE',
      GL: 'GREENLAND',
      GD: 'GRENADA',
      GP: 'GUADELOUPE',
      GU: 'GUAM',
      GT: 'GUATEMALA',
      GN: 'GUINEA',
      GY: 'GUYANA',
      HT: 'HAITI',
      HN: 'HONDURAS',
      HK: 'HONG KONG',
      HU: 'HUNGARY',
      IS: 'ICELAND',
      IN: 'INDIA',
      ID: 'INDONESIA',
      IR: 'IRAN',
      IQ: 'IRAQ',
      IE: 'IRELAND',
      IL: 'ISRAEL',
      IT: 'ITALY',
      JM: 'JAMAICA',
      JP: 'JAPAN',
      JO: 'JORDAN',
      KW: 'KUWAIT',
      KZ: 'KAZAKHSTAN',
      KE: 'KENYA',
      KI: 'KIRIBATI',
      KP: 'KOREA',
      KG: 'KYRGYZSTAN',
      LV: 'LATVIA',
      LB: 'LEBANON',
      LS: 'LESOTHO',
      LR: 'LIBERIA',
      LY: 'LIBYA',
      LI: 'LIECHTENSTEIN',
      LT: 'LITHUANIA',
      LU: 'LUXEMBOURG',
      MO: 'MACAO',
      MK: 'MACEDONIA',
      MG: 'MADAGASCAR',
      MW: 'MALAWI',
      MY: 'MALAYSIA',
      MV: 'MALDIVES',
      ML: 'MALI',
      MT: 'MALTA',
      MQ: 'MARTINIQUE',
      MR: 'MAURITANIA',
      MU: 'MAURITIUS',
      YT: 'MAYOTTE',
      MX: 'MEXICO',
      FM: 'MICRONESIA',
      MD: 'MOLDOVA',
      MC: 'MONACO',
      MN: 'MONGOLIA',
      ME: 'MONTENEGRO',
      MS: 'MONTSERRAT',
      MA: 'MOROCCO',
      MZ: 'MOZAMBIQUE',
      MM: 'MYANMAR',
      NA: 'NAMIBIA',
      NR: 'NAURU',
      NP: 'NEPAL',
      NL: 'NETHERLANDS',
      NC: 'NEW CALEDONIA',
      NZ: 'NEW ZEALAND',
      NI: 'NICARAGUA',
      NE: 'NIGER',
      NG: 'NIGERIA',
      NU: 'NIUE',
      NF: 'NORFOLK ISLAND',
      NO: 'NORWAY',
      OM: 'OMAN',
      PK: 'PAKISTAN',
      PW: 'PALAU',
      PS: 'PALESTINE',
      PA: 'PANAMA',
      PY: 'PARAGUAY',
      PE: 'PERU',
      PH: 'PHILIPPINES',
      PN: 'PITCAIRN',
      PL: 'POLAND',
      PT: 'PORTUGAL',
      PR: 'PUERTO RICO',
      QA: 'QATAR',
      RE: 'RÉUNION',
      RO: 'ROMANIA',
      RU: 'RUSSIAN FEDERATION',
      RW: 'RWANDA',
      SH: 'SAINT HELENA',
      LC: 'SAINT LUCIA',
      WS: 'SAMOA',
      SM: 'SAN MARINO',
      SA: 'SAUDI ARABIA',
      SN: 'SENEGAL',
      RS: 'SERBIA',
      SC: 'SEYCHELLES',
      SL: 'SIERRA LEONE',
      SG: 'SINGAPORE',
      SK: 'SLOVAKIA',
      SI: 'SLOVENIA',
      SB: 'SOLOMON ISLANDS',
      SO: 'SOMALIA',
      ZA: 'SOUTH AFRICA',
      SS: 'SOUTH SUDAN',
      ES: 'SPAIN',
      LK: 'SRI LANKA',
      SD: 'SUDAN',
      SR: 'SURINAME',
      SZ: 'SWAZILAND',
      SE: 'SWEDEN',
      CH: 'SWITZERLAND',
      SY: 'SYRIAN ARAB REPUBLIC',
      TW: 'TAIWAN',
      TJ: 'TAJIKISTAN',
      TZ: 'TANZANIA',
      TH: 'THAILAND',
      TL: 'TIMOR-LESTE',
      TG: 'TOGO',
      TK: 'TOKELAU',
      TO: 'TONGA',
      TT: 'TRINIDAD AND TOBAGO',
      TN: 'TUNISIA',
      TR: 'TURKEY',
      TM: 'TURKMENISTAN',
      TV: 'TUVALU',
      UG: 'UGANDA',
      UA: 'UKRAINE',
      AE: 'UNITED ARAB EMIRATES',
      GB: 'UNITED KINGDOM',
      US: 'UNITED STATES',
      UY: 'URUGUAY',
      UZ: 'UZBEKISTAN',
      VU: 'VANUATU',
      VE: 'VENEZUELA',
      VN: 'VIET NAM',
      YE: 'YEMEN',
      ZM: 'ZAMBIA',
      ZW: 'ZIMBABWE',
    },
    genders: {
      '': '--Please select--',
      M: 'Male',
      F: 'Female',
    },
    workspace_Capacity: {
      '': '--Please select--',
      0.5: 'Shifts',
      1.0: 'One Shift',
    },
    employmentType: {
      '': '--Please select--',
      F: 'Full Time',
      P: 'Part Time',
      C: 'Casual',
    },
    maritalStatus: {
      '': '--Please select--',
      S: 'Single',
      M: 'Married',
      W: 'Widowed',
      D: 'Divorced',
      P: 'Separated',
    },
    nightShiftOptions: [
      { key: false, value: 'All Shifts' },
      { key: true, value: 'Night Shift Only' },
    ],
    employeeStatus: [
      { key: false, value: 'Active Users' },
      { key: true, value: 'All Users' },
    ],
    positions: [],
    languages: [],
    computerSkill: [],
    currentPage: 'Dashboard',
    isLoading: false,
    teams: [],
    departments: [],
    teamOptions: [],
    taskOptions: [],
    taskCategoryOptions: [],
    reasonForMistakes: [],
    takenActions: [],
    bookingStatus: [],
    currencies: [],
    mistakeClassifications: [],
    mistakeTypes: [],
  },
  mutations: {
    updateDepartments(state, newInfo) {
      state.departments = newInfo;
    },
    updatePositions(state, newInfo) {
      state.positions = newInfo;
    },
    updateLanguages(state, newInfo) {
      state.languages = newInfo;
    },
    updateComputerSkill(state, newInfo) {
      state.computerSkill = newInfo;
    },
    updateIsLoading(state, newStatus) {
      state.isLoading = newStatus;
    },
    updateCurrentPage(state, newPage) {
      state.currentPage = newPage;
    },
    updateTeams(state, newInfo) {
      state.teams = newInfo;
    },
    updateTeamOptions(state, newInfo) {
      state.teamOptions = newInfo;
    },
    updateTaskOptions(state, newInfo) {
      state.taskOptions = newInfo;
    },
    updateTaskCategoryOptions(state, newInfo) {
      state.taskCategoryOptions = newInfo;
    },
    updateNightShiftOptions(state, newInfo) {
      state.nightShiftOptions = newInfo;
    },
    updateReasonForMistakes(state, newInfo) {
      state.reasonForMistakes = newInfo;
    },
    updateTakenActions(state, newInfo) {
      state.takenActions = newInfo;
    },
    updateBookingStatus(state, newInfo) {
      state.bookingStatus = newInfo;
    },
    updateCurrencies(state, newInfo) {
      state.currencies = newInfo;
    },
    updateMistakeClassifications(state, newInfo) {
      state.mistakeClassifications = newInfo;
    },
    updateMistakeTypes(state, newInfo) {
      state.mistakeTypes = newInfo;
    },
  },
  actions: {
    wait(context, toWait) {
      context.commit('updateIsLoading', toWait);
    },
    updateCurrentPage(context, newPage) {
      context.commit('updateCurrentPage', newPage);
    },
    getPositions(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/application/positions/',
        }).then((response) => {
          context.commit('updatePositions', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updatePositions', []);
          reject(error);
        });
      });
    },
    getLanguages(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/application/languages/',
        }).then((response) => {
          context.commit('updateLanguages', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateLanguages', []);
          reject(error);
        });
      });
    },
    getComputerSkill(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/application/computer-skill/',
        }).then((response) => {
          context.commit('updateComputerSkill', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateComputerSkill', []);
          reject(error);
        });
      });
    },
    getTeams(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/employee/teams/',
        }).then((response) => {
          context.commit('updateTeams', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateTeams', []);
          reject(error);
        });
      });
    },
    getTeamOptions(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/employee/team-options/',
        }).then((response) => {
          console.log('team options', response.data);
          context.commit('updateTeamOptions', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateTeamOptions', []);
          reject(error);
        });
      });
    },
    getTaskOptions(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/task-options/',
        }).then((response) => {
          context.commit('updateTaskOptions', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateTaskOptions', []);
          reject(error);
        });
      });
    },
    getTaskCategoryOptions(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/category-options/',
        }).then((response) => {
          context.commit('updateTaskCategoryOptions', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateTaskCategoryOptions', []);
          reject(error);
        });
      });
    },
    getDepartments(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/employee/department-options/',
        }).then((response) => {
          context.commit('updateDepartments', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateDepartments', []);
          reject(error);
        });
      });
    },
    getReasonForMistakes(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/reason-for-mistakes/',
        }).then((response) => {
          context.commit('updateReasonForMistakes', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateReasonForMistakes', []);
          reject(error);
        });
      });
    },
    getTakenActions(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/taken-actions/',
        }).then((response) => {
          context.commit('updateTakenActions', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateTakenActions', []);
          reject(error);
        });
      });
    },
    getBookingStatus(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/booking-status/',
        }).then((response) => {
          context.commit('updateBookingStatus', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateBookingStatus', []);
          reject(error);
        });
      });
    },
    getCurrencies(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/currencies/',
        }).then((response) => {
          context.commit('updateCurrencies', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateCurrencies', []);
          reject(error);
        });
      });
    },
    getMistakeClassifications(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/mistake-classifications/',
        }).then((response) => {
          context.commit('updateMistakeClassifications', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateMistakeClassifications', []);
          reject(error);
        });
      });
    },
    getMistakeTypes(context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/daily_operation/mistake-types/',
        }).then((response) => {
          context.commit('updateMistakeTypes', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateMistakeTypes', []);
          reject(error);
        });
      });
    },
  },
  getters: {
    getCountries(state) {
      return state.countries;
    },
    getNightShiftOptions(state) {
      return state.nightShiftOptions;
    },
    getGenders(state) {
      return state.genders;
    },
    getEmploymentType(state) {
      return state.employmentType;
    },
    getWorkspace(state) {
      return state.workspace_Capacity;
    },
    getMaritalStatus(state) {
      return state.maritalStatus;
    },
    getPositions(state) {
      return state.positions;
    },
    getLanguages(state) {
      return state.languages;
    },
    getComputerSkill(state) {
      return state.computerSkill;
    },
    isLoading(state) {
      return state.isLoading;
    },
    getCurrentPage(state) {
      return state.currentPage;
    },
    getTeams(state) {
      return state.teams;
    },
    getTeamOptions(state) {
      return state.teamOptions;
    },
    getTaskOptions(state) {
      return state.taskOptions;
    },
    getTaskCategoryOptions(state) {
      return state.taskCategoryOptions;
    },
    getDepartments(state) {
      return state.departments;
    },
    employeeStatus(state) {
      return state.employeeStatus;
    },
    reasonForMistakes(state) {
      return state.reasonForMistakes;
    },
    takenActions(state) {
      return state.takenActions;
    },
    bookingStatus(state) {
      return state.bookingStatus;
    },
    currencies(state) {
      return state.currencies;
    },
    mistakeClassifications(state) {
      return state.mistakeClassifications;
    },
    mistakeTypes(state) {
      return state.mistakeTypes;
    },
  },
};
